import {
  initialState,
  Actions,
  State,
  GET_ALL_COURSES,
  GET_ALL_COURSES_SUCCESS,
  GET_ALL_COURSES_ERROR,
  RESET_GET_ALL_COURSES,
} from '../../types/course/get-all.dto';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_COURSES:
      return {
        ...state,
        data: state.data,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case GET_ALL_COURSES_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case GET_ALL_COURSES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_GET_ALL_COURSES:
      return { ...initialState };
    default:
      return { ...state };
  }
};

export default reducers;